import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { Table } from '@platform-ui/design-system';
import { GenericWCWrapper } from '../utils';
export var DSTable = /*#__PURE__*/function (_GenericWCWrapper) {
  _inherits(DSTable, _GenericWCWrapper);

  var _super = _createSuper(DSTable);

  function DSTable() {
    _classCallCheck(this, DSTable);

    return _super.call(this, Table);
  }

  return DSTable;
}(GenericWCWrapper);

_defineProperty(DSTable, "_props", ['key'].concat(_toConsumableArray(Object.keys(Table['__docgenInfo'].props))));

export var DSTableMasterDetail = /*#__PURE__*/function (_HTMLElement) {
  _inherits(DSTableMasterDetail, _HTMLElement);

  var _super2 = _createSuper(DSTableMasterDetail);

  function DSTableMasterDetail() {
    var _this;

    _classCallCheck(this, DSTableMasterDetail);

    _this = _super2.call(this);

    _defineProperty(_assertThisInitialized(_this), "shadow", void 0);

    _this.shadow = _this.attachShadow({
      mode: 'open'
    });
    _this.shadow.innerHTML = "<div style=\"display: none;\"><slot></slot></div>";
    return _this;
  }

  _createClass(DSTableMasterDetail, [{
    key: "show",
    value: function show() {
      // @ts-ignore
      this.shadowRoot.firstChild.style.display = '';
    }
  }, {
    key: "hide",
    value: function hide() {
      // @ts-ignore
      this.shadowRoot.firstChild.style.display = 'none';
    }
  }]);

  return DSTableMasterDetail;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
//# sourceMappingURL=Table.js.map